export default () => {
  const url = new URL(window.location.href)
  const hash = url.hash
  return !!(hash && hash === '#quiz')
}
